export const CHINESE_NEW_YEAR = {
  2023: [1, 22],
  2024: [2, 10],
  2025: [1, 29],
  2026: [2, 17],
  2027: [2, 5],
  2028: [2, 26],
  2029: [2, 13],
  2030: [2, 3],
  2031: [1, 23],
  2032: [2, 11],
  2033: [1, 31],
}

// NEW_YEAR_LIST.put(2034, new Integer[] { 2, 19 });
// NEW_YEAR_LIST.put(2035, new Integer[] { 2, 8 });
// NEW_YEAR_LIST.put(2036, new Integer[] { 1, 28 });
// NEW_YEAR_LIST.put(2037, new Integer[] { 2, 14 });
// NEW_YEAR_LIST.put(2038, new Integer[] { 2, 4 });
// NEW_YEAR_LIST.put(2039, new Integer[] { 1, 24 });
// NEW_YEAR_LIST.put(2040, new Integer[] { 2, 12 });
